module.exports = __webpack_public_path__ + "img/licai.371933bf.png";